__turbopack_context__.v({
  "className": "cormorant_garamond_56d3d8e3-module__aGn9rq__className",
  "variable": "cormorant_garamond_56d3d8e3-module__aGn9rq__variable",
});
